import { render } from "./reg.vue?vue&type=template&id=9c21e9ee&scoped=true&ts=true"
import script from "./reg.vue?vue&type=script&lang=ts"
export * from "./reg.vue?vue&type=script&lang=ts"

import "./reg.vue?vue&type=style&index=0&id=9c21e9ee&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/mysystem_szzsfxhtml5_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c21e9ee"]])

export default __exports__